import { render, staticRenderFns } from "./sumAge.vue?vue&type=template&id=e09202be"
import script from "./sumAge.vue?vue&type=script&lang=js"
export * from "./sumAge.vue?vue&type=script&lang=js"
import style0 from "./sumAge.vue?vue&type=style&index=0&id=e09202be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports